<template>
  <div class="row m-0">
    <div class="col-12 p-0">
      <div class="row m-0 align-items-center justify-content-between">
        <div class="col-12 col-md px-md-1">
          <div class="border-divider"></div>
        </div>
        <div class="col-auto truncate bold px-md-1 order-md-first">
          {{store.details.name}}
        </div>
        <div class="col-auto order-last pl-0 px-md-1 py-2">
          <button class="btn btn-outline w-100" @click="goToStore">
            View Store
          </button>
        </div>
      </div>
    </div>
    <div class="col-12 p-0">
      <store-products :products="store.products" :storeLink="store.details.domain"></store-products>
    </div>
  </div>
</template>

<script>
export default {
  props: ['store'],
  components: {
    'store-products': () => import('@/components/landing/StoreProducts.vue')
  },
  data () {
    return {
      showMore: false
    }
  },
  methods: {
    goToStore (storeId) {
      this.$router.push(`/${this.store.details.domain}/store`)
    }
  }
}
</script>
<style scoped>
  .border-divider {
    border-bottom: 2px solid var(--dark-color);
  }
  .dark-mode .border-divider {
    border-bottom: 2px solid var(--light-color);
  }
  .col-auto.truncate {
    max-width: 70%;
  }
  .truncate {
    word-wrap: break-word;
    overflow-y: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    height: 1;
  }
  @media (min-width: 768px) {
    .col-auto.truncate {
    max-width: 50%;
  }
  }
</style>
